// import Vue from "vue";
import { createApp } from "vue";
import App from "./App.vue";
import VueApexCharts from "vue3-apexcharts";
import router from "./router";
import { globalStore as store } from "./store/index.js";
import "./registerServiceWorker";
import "./styles/index.css";

const app = createApp(App);

app.config.productionTip = false; // puxar do env

// Vue.use(VueApexCharts);
// Vue.component("ApexChart", VueApexCharts);
// Vue.component(router);

app
  .use(router)
  .use(store)
  .use(VueApexCharts)
  .component("ApexChart", VueApexCharts)
  .mount("#app");
